import { useRef } from 'react';

import { TextInput } from 'cpool-components/input/TextInput';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormRow } from '~/components/FormRow/FormRow';
import { SectionCard } from '~/components/SectionCard/SectionCard';

const FILE_PICKER_CLASSES =
    'flex-1 bg-white border border-grey-stroke rounded h-8 px-2 font-roboto text-sm text-midnight outline-none cursor-pointer';

export const SMimeCert: React.FC<{ disabled?: boolean; outlined?: boolean }> = ({ disabled, outlined }) => {
    const { t } = useTranslation();
    const { register, setValue, watch } = useFormContext();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const certFileName = watch('certFileName');

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setValue('certFileName', file.name);
        setValue('certFile', file);
    };

    return (
        <SectionCard title={t('users.create.MODAL.CERTIFICATE.TITLE')} outlined={outlined}>
            <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                    <label className="w-48 shrink-0 text-sm text-midnight">
                        {t('users.create.MODAL.CERTIFICATE.CERT_FILE')}
                    </label>
                    <input
                        type="text"
                        readOnly
                        disabled={disabled}
                        value={certFileName ?? ''}
                        placeholder={t('users.create.MODAL.CERTIFICATE.SELECT_FILE')}
                        className={FILE_PICKER_CLASSES}
                        onClick={() => fileInputRef.current?.click()}
                    />
                    <input
                        ref={fileInputRef}
                        data-testid="cert-file-input"
                        type="file"
                        className="hidden"
                        accept="application/x-pkcs12"
                        onChange={handleFileSelect}
                    />
                </div>
                <FormRow label={t('users.create.MODAL.CERTIFICATE.CERT_PASSWORD')} htmlFor="certPassword">
                    <TextInput
                        id="certPassword"
                        className="grow"
                        type="password"
                        disabled={disabled}
                        placeholder={t('FORM_FIELDS.PASSWORD')}
                        {...register('certPassword')}
                    />
                </FormRow>
            </div>
        </SectionCard>
    );
};
